import ClaimedSongsList from 'components/Thumbrace/ClaimedSongsList';
import React from 'react';

export default function ThumbracePage() {
  return <ClaimedSongsList />;
}
